import { ChangeEvent, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Heading,
  Image,
  Input,
  Text,
  Textarea,
  Wrap,
  useBoolean,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import usePathNavigate from "../lib/hook/usePathNavigate";
import { companyInfoState, companyNameState } from "../lib/atoms/companyState";
import RadioButtons from "../components/RadioButtons";
import CaptureButton from "../components/CaptureButton";
import { captureListState } from "../lib/atoms/captureState";
import history from "../router/history";
import PreviewImageModal from "../components/PreviewImageModal";
import ShippingInput from "../components/ShippingInput";
import { Address } from "react-daum-postcode";
import { serviceAreaAry } from "../assets/servicearea";
import { onRegexValidationPhone } from "../lib/util/regular";
import DaumPostCodeModal from "../components/DaumPostCodeModal";
import imageCompression from "browser-image-compression";
import { getSign, setImageMint, setOrderSet } from "./api";
import { ResStatus } from "../lib/api/enum";
import OneButtonModal from "../components/OneButtonModal";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useQuery } from "@tanstack/react-query";
import CouponInput from "../components/CouponInput";
import { CouponLookupModel } from "./api/type";
import FullScreenLoader from "../components/FullScreenLoader";

function Order() {
  const { pathNavigate, backNavigate } = usePathNavigate();

  const toast = useToast();

  const companyName = useRecoilValue(companyNameState);
  const companyInfo = useRecoilValue(companyInfoState);
  const [token, setToken] = useState<string>("");
  const [receiptCode, setReceiptCode] = useState<string>("XXXXXX-XXX");

  const [isLoading, setLoading] = useState<boolean>(false);

  const { error } = useQuery({
    queryKey: ["getSign"],
    queryFn: async () => {
      const company_name =
        window.location.origin.includes("dev-") ||
        window.location.origin.includes("http://")
          ? "dev-" + companyName
          : window.location.origin.includes("test-")
          ? "test-" + companyName
          : companyName;

      const response = await getSign({
        oem_code: company_name,
      });
      if (response.status === ResStatus.RES_SUCCESS) {
        setToken(response.access_token);
      } else {
        toast({
          title: "오류",
          description: response.result_message,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
      }
      return response;
    },
  });

  if (error) {
  }

  const [brandName, setBrandName] = useState<string>("");
  const onClickBrandsHandler = (value: string) => {
    setBrandName(value);
  };

  const [itemName, setItemName] = useState<string>("");
  const onChangeItemName = (e: ChangeEvent<HTMLInputElement>) => {
    setItemName(e.target.value);
  };
  // const isNumeric = (val: string) => {
  //   return val === '' || /^[0-9 ]+$/.test(val);
  // };
  // const isNumericAlphabet = (val: string) => {
  //   return val === '' || /^[A-Za-z0-9]+$/.test(val);
  // };
  const isHangul = (val: string) => {
    return /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(val);
  };
  const [itemSize, setItemSize] = useState<string>("");
  const onChangeSize = (e: ChangeEvent<HTMLInputElement>) => {
    if (!isHangul(e.target.value)) setItemSize(e.target.value);
  };

  const [captureList, setCaptureList] = useRecoilState(captureListState);
  const [repairRequestValue, setRepairRequestValue] = useState("");
  const onChangeRepairRequestValue = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setRepairRequestValue(e.target.value);
  };

  // 이용권 리스트
  const [couponList, setCouponList] = useState<CouponLookupModel[]>([]);

  // 이름
  const [name, setName] = useState<string>("");
  const onChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  // 전화번호
  const [phone, setPhone] = useState<string>("");
  const onChangePhone = (e: ChangeEvent<HTMLInputElement>) => {
    const phoneNum = onRegexValidationPhone(e.target.value);
    setPhone(phoneNum);
  };

  // 주소
  const [addressData, setAddressData] = useState({
    zonecode: "",
    roadAddress: "",
    sido: "",
    sigungu: "",
    sigunguCode: "",
    detailAddress: "",
  });
  const [activePost, setActivePost] = useBoolean(false);
  const [isArea, setIsArea] = useState<boolean>();

  const callbackPostCode = (data?: Address) => {
    setActivePost.off();
    if (data === null || data === undefined) return;

    setAddressData({
      zonecode: data.zonecode,
      roadAddress: data.roadAddress,
      sido: data.sido,
      sigungu: data.sigungu,
      sigunguCode: data.sigunguCode,
      detailAddress: "",
    });
    const areaAry: string[] = serviceAreaAry() as string[];
    const area = areaAry.some((code) => code === data.sigunguCode);
    setIsArea(area);
  };
  const onChangeDetailAddress = (e: ChangeEvent<HTMLInputElement>) => {
    setAddressData((prevState) => ({
      ...prevState,
      detailAddress: e.target.value,
    }));
  };
  // 배송요청사항
  const [deliverRequestValue, setDeliverRequestValue] = useState("");
  const onChangeDeliverRequestValue = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDeliverRequestValue(e.target.value);
  };

  const {
    isOpen: imageIsOpen,
    onClose: imageClose,
    onOpen: imageOpen,
  } = useDisclosure();
  const [previewImage, setPreviewImage] = useState("");
  const onPreviewImage = (previewImage: string) => {
    setPreviewImage(previewImage);
    imageOpen();
  };

  const uploadImages = async () => {
    if (captureList.length > 0) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 2048,
          useWebWorker: true,
          fileType: "image/jpeg",
        };
        const responseList = await Promise.all(
          captureList.map(async (pic, index) => {
            try {
              const compressedFile = await imageCompression(
                pic.imageFile,
                options
              );
              const base64File: string =
                await imageCompression.getDataUrlFromFile(compressedFile);
              const result = await setImageMint({
                files: base64File.replace("data:image/jpeg;base64,", ""),
                contents_type: "order",
              });
              if (result.status !== ResStatus.RES_SUCCESS) {
                return -1;
              }

              return result.command.image_id;
            } catch (error: any) {
              throw new Error(
                `Image compression or upload failed for image at index ${index}: ${error.message}`
              );
            }
          })
        );
        return responseList;
      } catch (error: any) {
        console.error(`Error in uploadImages: ${error.message}`);
        throw error;
      }
    }
    return [];
  };

  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const onSubmitAS = async () => {
    if (token === "" || token === undefined) {
      toast({
        description: "권한이 없습니다",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
      return;
    }
    if (isSubmitLoading) {
      toast({
        description: "신청을 처리 중입니다",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
      return;
    }
    setIsSubmitLoading(true);
    try {
      const uploadResults = await uploadImages();
      if (uploadResults.length === 0) {
        const coupon_list = couponList.map((menu, index) => menu.coupon_code);
        const result = await setOrderSet({
          brand_name: brandName,
          item_name: itemName,
          item_size: itemSize,
          image_id: [],
          comment: repairRequestValue,
          address_name: name,
          address_phone: phone,
          address: addressData.roadAddress,
          address_detail: addressData.detailAddress,
          post_num: addressData.zonecode,
          sido: addressData.sido,
          sigungu: addressData.sigungu,
          sigungu_code: addressData.sigunguCode,
          delivery_comment: deliverRequestValue,
          coupon_code: coupon_list,
        });
        if (result?.status === ResStatus.RES_SUCCESS) {
          setReceiptCode(result.command.receipt_code);
          setCaptureList([]);
          setCouponList([]);
          saveOpen();
        } else {
          console.log(result.status + ": " + result.result_message);
          toast({
            title: "실패",
            description: result?.status + "/" + result.result_message,
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top",
          });
        }
      } else {
        const imageIdList = uploadResults.filter((imageId) => imageId !== -1);
        console.log("imageIdList", uploadResults, imageIdList);
        if (
          imageIdList &&
          imageIdList.length > 0 &&
          uploadResults.length === imageIdList.length
        ) {
          const coupon_list = couponList.map((menu, index) => menu.coupon_code);
          const result = await setOrderSet({
            brand_name: brandName,
            item_name: itemName,
            item_size: itemSize,
            image_id: imageIdList,
            comment: repairRequestValue,
            address_name: name,
            address_phone: phone,
            address: addressData.roadAddress,
            address_detail: addressData.detailAddress,
            post_num: addressData.zonecode,
            sido: addressData.sido,
            sigungu: addressData.sigungu,
            sigungu_code: addressData.sigunguCode,
            delivery_comment: deliverRequestValue,
            coupon_code: coupon_list,
          });
          if (result?.status === ResStatus.RES_SUCCESS) {
            setReceiptCode(result.command.receipt_code);
            setCaptureList([]);
            setCouponList([]);
            saveOpen();
          } else {
            console.log(result.status + ": " + result.result_message);
            toast({
              title: "실패",
              description: result?.status + "/" + result.result_message,
              status: "error",
              duration: 3000,
              isClosable: true,
              position: "top",
            });
          }
        } else {
          toast({
            title: "오류",
            description: "이미지 업로드 실패",
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top",
          });
        }
      }
    } catch (err: any) {
      toast({
        title: "오류-catch",
        description: err.message,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const {
    isOpen: saveIsOpen,
    onClose: saveClose,
    onOpen: saveOpen,
  } = useDisclosure();
  const onClickSave = () => {
    pathNavigate("/");
  };

  useEffect(() => {
    const listenBackEvent = () => {
      console.log("reset capture list");
      setCaptureList([]);
    };
    const unlistenHistoryEvent = history.listen(({ action }) => {
      if (action === "POP") {
        listenBackEvent();
      }
    });
    return unlistenHistoryEvent;
  }, [history]);

  // console.log(companyInfo[companyName], companyInfo[companyName]?.coupon);

  return (
    <Box>
      {isLoading && <FullScreenLoader />}
      <HStack position={"relative"}>
        <Center
          w="100%"
          h="60px"
          bgColor={"white"}
          fontSize="20px"
          borderBottomWidth={"1px"}
          fontWeight={"semibold"}
        >
          {companyInfo[companyName]?.ordertitle}
        </Center>
        <ArrowBackIcon
          position={"absolute"}
          left={"16px"}
          boxSize={"24px"}
          onClick={() => {
            backNavigate();
          }}
        />
      </HStack>
      <Box alignItems={"flex-start"} mt={"36px"} mb={"20px"} px={"20px"}>
        <Heading fontSize={"16px"} fontWeight="semibold" mb={"16px"}>
          제품 분류 *
        </Heading>
        {companyInfo && companyInfo[companyName] && (
          <RadioButtons
            radioGroupName="category"
            buttonList={companyInfo[companyName].brands}
            buttonSize={{ w: "105px", h: "54px" }}
            onChange={onClickBrandsHandler}
          />
        )}
      </Box>
      <Box w={"100%"} h="8px" bg="#f5f6f8" />
      <Box alignItems={"flex-start"} mt={"20px"} mb={"20px"} px={"20px"}>
        <Heading fontSize={"16px"} fontWeight="semibold" mb={"16px"}>
          제품 정보
        </Heading>
        <Text fontSize={"13px"} fontWeight="semibold" mb={"8px"}>
          제품명 (선택)
        </Text>
        <Input
          w="100%"
          h={"54px"}
          fontSize={"1rem"}
          fontWeight="semibold"
          focusBorderColor={"black"}
          borderColor={"#eee"}
          borderRadius="base"
          placeholder="제품 모델명만 입력하세요 (컬러 제외)"
          _placeholder={{ color: "#bdbdbd", fontSize: "0.875rem" }}
          maxLength={30}
          value={itemName}
          onChange={onChangeItemName}
        />
        <Text fontSize={"13px"} fontWeight="semibold" mt={"24px"} mb={"8px"}>
          제품 사이즈 *
        </Text>
        <Input
          w="100%"
          h={"54px"}
          fontSize={"1rem"}
          fontWeight="semibold"
          focusBorderColor={"black"}
          borderColor={"#eee"}
          borderRadius="base"
          placeholder="제품 사이즈를 입력하세요"
          _placeholder={{ color: "#bdbdbd", fontSize: "0.875rem" }}
          value={itemSize}
          onChange={onChangeSize}
          // type="tel"
          // maxLength={3}
        />
      </Box>
      <Box w={"100%"} h="8px" bg="#f5f6f8" />
      {companyInfo[companyName]?.coupon === "false" && (
        <Box my={"20px"} px={"20px"}>
          <Heading fontSize={"16px"} fontWeight="semibold" mb={"16px"}>
            수선 정보
          </Heading>
          <Text fontSize={"13px"} fontWeight="semibold" mb={"8px"}>
            {companyInfo[companyName]?.phototitle}
          </Text>
          <Box>
            <Wrap spacing={"5px"} overflow="visible">
              <CaptureButton
                slotId={0}
                onPreviewImage={onPreviewImage}
                setLoading={setLoading}
              />
              <CaptureButton
                slotId={1}
                onPreviewImage={onPreviewImage}
                setLoading={setLoading}
              />
              <CaptureButton
                slotId={2}
                onPreviewImage={onPreviewImage}
                setLoading={setLoading}
              />
              <CaptureButton
                slotId={3}
                onPreviewImage={onPreviewImage}
                setLoading={setLoading}
              />
            </Wrap>
          </Box>
          <Text fontSize={"13px"} fontWeight="semibold" mt={"24px"} mb={"8px"}>
            수선 요청 사항 *
          </Text>
          <Textarea
            w={"100%"}
            h={"84px"}
            resize="vertical"
            fontSize={"1rem"}
            focusBorderColor={"black"}
            borderColor={"#eee"}
            borderRadius="base"
            placeholder="원하시는 수선 내용을 되도록 상세하게 써 주세요."
            css={{ resize: "none" }}
            _placeholder={{ color: "#bdbdbd", fontSize: "0.875rem" }}
            value={repairRequestValue}
            onChange={onChangeRepairRequestValue}
            maxLength={120}
          />
        </Box>
      )}
      {companyInfo[companyName]?.coupon === "false" && (
        <Box w={"100%"} h="8px" bg="#f5f6f8" />
      )}
      {companyInfo[companyName]?.coupon === "true" && (
        <CouponInput couponList={couponList} setCouponList={setCouponList} />
      )}
      {companyInfo[companyName]?.coupon === "true" && (
        <Box w={"100%"} h="8px" bg="#f5f6f8" />
      )}
      <Box px="20px" mt="20px">
        <ShippingInput
          title="접수자 정보 *"
          name={name}
          phone={phone}
          addressData={addressData}
          callBackName={onChangeName}
          callBackPhone={onChangePhone}
          callBackSearchPostCode={setActivePost.toggle}
          callBackDetailAddress={onChangeDetailAddress}
        />
        <Input
          h="54px"
          mt={"8px"}
          fontSize={"1rem"}
          fontWeight="medium"
          focusBorderColor={"black"}
          borderColor={"#eee"}
          borderRadius="base"
          _placeholder={{ color: "#bdbdbd", fontSize: "0.875rem" }}
          maxLength={50}
          type="text"
          placeholder="배송 요청 사항"
          value={deliverRequestValue}
          onChange={onChangeDeliverRequestValue}
        />
      </Box>
      <Box w={"full"} px="30px">
        <Button
          colorScheme={"black_button"}
          w="100%"
          h={"50px"}
          mt={"36px"}
          mb={"36px"}
          borderRadius={"base"}
          fontSize={"18px"}
          fontWeight="semibold"
          isLoading={isSubmitLoading}
          isDisabled={
            companyInfo[companyName]?.coupon === "true"
              ? brandName === "" ||
                itemSize === "" ||
                name === "" ||
                phone === "" ||
                addressData.zonecode === "" ||
                addressData.roadAddress === "" ||
                couponList.length === 0 ||
                (companyInfo[companyName]?.photorequired === "true" &&
                  captureList.length < 2)
              : brandName === "" ||
                itemSize === "" ||
                repairRequestValue === "" ||
                name === "" ||
                phone === "" ||
                addressData.zonecode === "" ||
                addressData.roadAddress === "" ||
                (companyInfo[companyName]?.photorequired === "true" &&
                  captureList.length < 2)
          }
          onClick={onSubmitAS}
        >
          {companyInfo[companyName]?.orderbutton}
        </Button>
      </Box>
      <PreviewImageModal
        isOpen={imageIsOpen}
        onClose={imageClose}
        previewImage={previewImage}
      />
      <OneButtonModal
        isOpen={saveIsOpen}
        buttonText="확인"
        onClose={saveClose}
        onClickButton={onClickSave}
      >
        <Flex
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems="center"
        >
          <Image
            src="/assets/images/icn_circle_check.svg"
            mt="20px"
            boxSize={"56px"}
          />
          <Text mt="15px" fontSize={"1rem"} fontWeight="semibold">
            {companyInfo[companyName]?.ordertitle === "true"
              ? "접수"
              : "A/S 접수" + "가 성공적으로"}
          </Text>
          <Text fontSize={"1rem"} fontWeight="semibold">
            등록 되었습니다.
          </Text>
          <Text mt="15px" fontSize={"1rem"} fontWeight="semibold">
            접수번호 : {receiptCode}
          </Text>
        </Flex>
      </OneButtonModal>
      <DaumPostCodeModal isOpen={activePost} callback={callbackPostCode} />
    </Box>
  );
}

export default Order;
